import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-head',
  templateUrl: './head.component.html',
  styleUrls: ['./head.component.scss']
})
export class HeadComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {

  }

  OpenMenu() {
    if (document.getElementById('sidenav-mobile') != null) {
      document.getElementById('sidenav-mobile').style.width = '320px';
    }
    if (document.getElementById('opacity') != null) {
      document.getElementById('opacity').style.display = 'block';
    }
  }
}
